<template>
  <v-app>
    <v-main class="pb-5"> 
      <Header :quantity="quantity"></Header>
      <Banner></Banner>
      <router-view @addToBasket="addToBasket" />
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
import Banner from "@/components/Banner.vue";

export default {
  name: "App",

  components: {
    Header,
    Banner,
  },

  data() {
    return {
      quantity: 1 
    }
  },

  methods: {
    addToBasket() {
      // this.quantity = 1;
      this.$router.push({ name: 'Cart'});
    }
  }
};
</script>

<style>
.teal-text {
  color: #68dcbb;
}

.teal-text-dark {
  color: #2dc59a;
}

.teal-bg {
  background-color: #68dcbb;
}

.teal-bg-dark {
  background-color: #2dc59a;
}
</style>